import { AppLink } from '@components/common/AppLink';
import ImgLazy from '@components/img-lazy';
import { KolProfileBaseFragment } from '@graphqlTypes/sitecore';

interface Props {
    kolDataList: KolProfileBaseFragment[];
    isSharePage?: boolean;
}

const FilterKolTabs = (props: Props) => {
    const { kolDataList, isSharePage = false } = props;
    const sortedData = [...kolDataList].sort((a, b) => {
        const getOrderValue = (item: (typeof kolDataList)[0]): number => {
            const raw = item.tippingOneOrder?.value?.trim();
            if (!raw) return Infinity;
            const num = parseInt(raw, 10);
            return isNaN(num) ? Infinity : num;
        };

        return getOrderValue(a) - getOrderValue(b);
    });
    return (
        <div className='flex gap-3 text-center overflow-x-auto last:pr-7 hide-scrollbar'>
            {sortedData.map((i, index) => {
                const profileUrl = `/kol-profile/${i.name}/`;
                return (
                    <div key={index}>
                        {isSharePage ? (
                            <>
                                <ImgLazy
                                    src={i.kolThumbSq?.src ?? ''}
                                    classNames='rounded-full'
                                    width={56}
                                    height={56}
                                ></ImgLazy>
                                <div className='text-[11px] text-[#012E65] font-bold pt-1 pb-3'>
                                    {i.kolName?.value}
                                </div>
                            </>
                        ) : (
                            <AppLink href={profileUrl}>
                                <ImgLazy
                                    src={i.kolThumbSq?.src ?? ''}
                                    classNames='rounded-full'
                                    width={56}
                                    height={56}
                                ></ImgLazy>
                                <div className='text-[11px] text-[#012E65] font-bold pt-1 pb-3'>
                                    {i.kolName?.value}
                                </div>
                            </AppLink>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default FilterKolTabs;
